/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Field_Source_LotInputs */

const vi_pdc_field_source_lot = /** @type {(inputs: Pdc_Field_Source_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô nguồn`)
};

/**

* @param {Pdc_Field_Source_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_field_source_lot = /** @type {((inputs?: Pdc_Field_Source_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Field_Source_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_field_source_lot(inputs)
});